import React from 'react';
import Helmet from 'react-helmet';
import styled from '@emotion/styled';
import { useLocation } from 'react-router';

import RegistrationContainer from './components/containers/RegistrationContainer';
import BackgroundSlidesPageContainer from '../login/components/shared/BackgroundSlidesPageContainer';
import useBackgroundSlides, { createLoginSlides } from '../login/components/hooks/useBackgroundSlides';

const slides = createLoginSlides(12);

const ResponsiveContainer = styled(BackgroundSlidesPageContainer)`
  @media screen and (max-width: 768px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  @media screen and (max-width: 425px) {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const Registration = () => {
  const { imageTransition } = useBackgroundSlides(slides);
  const { pathname } = useLocation();
  const helmetTitle = pathname.includes('easy-join') ? 'Easy Join | TeamBuildr' : 'Registration | TeamBuildr';

  return (
    <ResponsiveContainer
      alignItems='flex-start'
      as='main'
      fullHeight
      imageHeight='auto'
      imageMinHeight='100%'
      imagePosition='fixed'
      imageTransition={imageTransition}
      imageZIndex='0'
      overflowY='auto'
      paddingBottom='40px'
      paddingTop='40px'
      position='relative'
    >
      <Helmet>
        <title>{helmetTitle}</title>
      </Helmet>
      <RegistrationContainer />
    </ResponsiveContainer>
  );
};

export default Registration;
